import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";

@Component({
    selector: "web-panel-charges-details",
    templateUrl: "./panel-charges-details.component.html",
    styleUrls: ["./panel-charges-details.component.scss"],
})
export class PanelChargesDetailsComponent {
    penalCharges: any[] = [];
    penalChargesDetails: any;

    constructor(public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.penalChargesDetails = data?.penalChargesDetails || {};
        this.penalCharges = this.penalChargesDetails?.penalCharges || [];
    }
}
